import React, { useState } from 'react';
import { MdAnalytics } from 'react-icons/md';
import { HiOutlineGlobeAlt } from 'react-icons/hi';

const Features = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const features = [
    {
      title: 'Node Monitoring',
      description: 'Monitor your servers in real time with clear insights into uptime, latency, and performance. Quickly add IPs and ports using a simple form and start tracking instantly. View all nodes in a live list with easy access to detailed graphs. Stay ahead of issues and keep your systems running smoothly—24/7.',
      icon: <MdAnalytics size={40} color="#2065D1" />,
    },
    {
      title: 'API Monitoring',
      description: 'The API Monitor is designed to help you track API efficiently. Monitor your API with ease, stay on top of their health, and get live status updates instantly—just a few clicks away.',
      icon: <HiOutlineGlobeAlt size={40} color="#2065D1" />,
    },
  ];

  return (
    <section id='services' style={styles.section}>
      <h2 style={styles.heading}>Services</h2>
      <div style={styles.cardWrapper}>
        {features.map((f, i) => (
          <div
            key={i}
            style={{
              ...styles.card,
              ...(hoveredIndex === i ? styles.cardHover : {}),
            }}
            onMouseEnter={() => setHoveredIndex(i)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            <div style={styles.icon}>{f.icon}</div>
            <h3 style={styles.cardTitle}>{f.title}</h3>
            <p style={styles.cardText}>{f.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

const styles = {
  section: {
    backgroundColor: '#f8fbff',
    padding: '60px 20px',
    textAlign: 'center',
  },
  heading: {
    color: '#0d1b2a',
    fontSize: '2.75rem',
    marginBottom: '40px',
    fontWeight: 700,
  },
  cardWrapper: {
    display: 'flex',
    flexDirection: 'row',
    gap: '24px',
    justifyContent: 'center',
    flexWrap: 'wrap',
    maxWidth: '1200px',
    margin: '0 auto',
  },
  card: {
    backgroundColor: '#ffffff',
    borderRadius: '16px',
    padding: '32px 24px',
    flex: '1 1 300px',
    width: '700px',
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.06)',
    textAlign: 'left',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    cursor: 'default',
  },
  cardHover: {
    transform: 'translateY(-6px)',
    boxShadow: '0 16px 32px rgba(0, 0, 0, 0.1)',
  },
  icon: {
    marginBottom: '20px',
  },
  cardTitle: {
    color: '#0d47a1',
    fontSize: '1.5rem',
    fontWeight: 600,
    marginBottom: '12px',
  },
  cardText: {
    color: '#003366',
    fontSize: '1rem',
    lineHeight: '1.6',
  },
};

export default Features;
